<template>
    <v-dialog v-model="dialog" max-width="800">
        <v-card>
            <v-card-title class="info white--text">
                <v-icon dark class="mr-2">mdi-history</v-icon>
                Histórico de Assinaturas
                <v-spacer></v-spacer>
                <v-btn icon small @click="dialog = false">
                    <v-icon color="red lighten-2" small>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pt-4">
                <v-progress-linear v-if="loadingHistory" indeterminate color="primary"></v-progress-linear>
                <v-alert v-else-if="signatureHistory.length === 0" type="info" dense outlined>
                    Nenhum histórico de assinatura encontrado para esta folha de ponto.
                </v-alert>
                <emc-util-scroll v-else maxHeight="60vh">
                    <v-timeline dense>
                        <v-timeline-item
                            v-for="(historyItem, index) in signatureHistory"
                            :key="index"
                            :color="getHistoryColor(historyItem.action)"
                            :icon="getHistoryIcon(historyItem.action)"
                            small
                        >
                            <v-card class="elevation-2">
                                <v-card-title class="text-subtitle-2 py-2">
                                    {{ historyItem.action_label }}
                                    <v-spacer></v-spacer>
                                    <span class="text-caption">{{ historyItem.created_at }}</span>
                                </v-card-title>
                                <v-card-text class="py-2">
                                    <div><strong>Responsável:</strong> {{ historyItem.user_name }}</div>
                                    <div><strong>Status:</strong> {{ historyItem.sign_status }}</div>
                                    <div v-if="historyItem.reason">
                                        <strong>Justificativa:</strong> {{ historyItem.reason }}
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-timeline-item>
                    </v-timeline>
                </emc-util-scroll>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="dialog = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: "SysOccurrenceSignatureHistoryDialog",
    data: () => ({
        dialog: false,
        signatureHistory: [],
        loadingHistory: false,
    }),
    props: {
        show: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: () => ({})
        }
    },
    watch: {
        dialog(dialog_new, dialog_old) {
            if (dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }
        },
        show(show_new) {
            this.dialog = show_new;

            if (show_new) {
                this.loadSignatureHistory();
            } else {
                this.signatureHistory = [];
            }
        },
    },
    methods: {
        ...mapActions('timeSheet', ['ActionSignatureHistoryOccurrenceSheet']),

        loadSignatureHistory() {
            this.loadingHistory = true;

            this.ActionSignatureHistoryOccurrenceSheet({
                id: this.item.id
            })
                .then((res) => {
                    this.signatureHistory = res.data || [];
                })
                .catch(() => {
                    this.signatureHistory = [];
                })
                .finally(() => {
                    this.loadingHistory = false;
                });
        },

        getHistoryColor(action) {
            const colors = {
                'sent': 'purple',
                'cancelled': 'error',
                'signed': 'success',
                'refused': 'deep-orange',
            };
            return colors[action] || 'grey';
        },

        getHistoryIcon(action) {
            const icons = {
                'sent': 'mdi-send',
                'cancelled': 'mdi-cancel',
                'signed': 'mdi-check-circle',
                'refused': 'mdi-close-circle',
            };
            return icons[action] || 'mdi-information';
        },
    }
}
</script>
